import { render } from "./dgpoSlider.vue?vue&type=template&id=6af6c474&scoped=true"
import script from "./dgpoSlider.vue?vue&type=script&lang=js"
export * from "./dgpoSlider.vue?vue&type=script&lang=js"

import "./dgpoSlider.vue?vue&type=style&index=0&id=6af6c474&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6af6c474"]])

export default __exports__